import { ControlStoreImpl } from './reportStoreImpl';
import { ReportStoreConfig } from './reportStoreConfig';

export function createReportStore(config: Pick<ReportStoreConfig, 'initialValues'>) {
    return new ControlStoreImpl({
        initialValues: config.initialValues,
    });
}
